export function parseFloat(firmwareVersion: string): number {
  if (!/.\d{3}\.\d\w\d/.test(firmwareVersion)) {
    throw 'Unsupported firmware version ' + firmwareVersion;
  }

  const majorVersion = parseInt(firmwareVersion.substring(1, 4));
  const minorVersion = parseInt(firmwareVersion.charAt(7));

  const major =
    firmwareVersion.charAt(0) == 'T' ? majorVersion + 6 : majorVersion;
  const minor = minorVersion;

  return major + minor / 10;
}

export function getSchemaVersion(firmwareVersion: string): string {
  const ver = parseFloat(firmwareVersion);

  if (ver >= 10.3) return '0010.0R3';
  else if (ver >= 9.5) return '0009.0R5';
  else if (ver >= 9.0) return '0009.0R0';
  else if (ver >= 8.9) return '0008.0R9';
  else if (ver >= 8.6) return '0008.0R6';
  else if (ver >= 8.4) return '0008.0R4';
  else if (ver >= 8.0) return '0008.0R0';
  else if (ver >= 7.6) return '0007.0R6';
  else if (ver >= 7.5) return '0007.0R5';
  else if (ver >= 7.2) return '0007.0R2';
  else if (ver >= 7.0) return '0007.0R0';
  else if (ver >= 6.8) return '0006.0R8';
  else if (ver >= 6.7) return '0006.0R7';
  else if (ver >= 6.5) return '0006.0R5';
  else if (ver >= 5.2) return '0005.0R2';
  else if (ver >= 5.0) return '0005.0R0';
  else if (ver >= 4.2) return '0004.0R2';
  else throw 'Unsupported firmware version ' + firmwareVersion;
}
